import { Button } from './Button';

export const ConfirmModal = ({ title, content, onConfirm, onClose }) => {
  return (
    <>
      <div className="fixed top-0 left-0 h-screen w-screen backdrop-blur-[2px]"></div>
      <div className="absolute top-1/2 left-1/2 z-50 flex w-5/6 -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-2 rounded-3xl bg-white/85 py-10 shadow-2xl">
        <span className="text-3xl font-bold">{title}</span>
        <p className="px-3">{content}</p>
        <div className="flex gap-4">
          <Button label="Cancel" onClick={onClose} />
          <Button label="Confirm" onClick={() => onConfirm()} variant="primary" />
        </div>
      </div>
    </>
  );
};
